import { render, staticRenderFns } from "./Complex.vue?vue&type=template&id=a868ba24&scoped=true"
import script from "./Complex.vue?vue&type=script&lang=js"
export * from "./Complex.vue?vue&type=script&lang=js"
import style0 from "./Complex.vue?vue&type=style&index=0&id=a868ba24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a868ba24",
  null
  
)

export default component.exports